import flagxs_logo_tagline_monotone from '../../../assets/flagxs_logo_tagline_monotone.svg'
import people_at_the_table from '../../../assets/people_at_the_table.svg'
import { styled } from '@mui/material'
import { intl } from '../../../i18n'
import { useDispatch, useSelector } from 'react-redux'
import { AllState } from '../../../store'
import { useEffect, useState } from 'react'
import { loginToProjectByCode } from '../../../store/project'

const NotFoundTitle = styled('div')({
  fontSize: '14px',
  fontWeight: '600',
  lineHeight: '21px',
  letterSpacing: '0em',
  textAlign: 'center',
  color: '#7B8CAA',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  whiteSpace: 'pre-line',
  padding: '10px',
})
const NotFoundContent = styled('div')({
  display: 'flex',
  width: '476px',
  height: '70px',
  borderRadius: '4px',
  border: '1px solid #D8DDE5',
  gap: '10px',
  backgroundColor: '#F7F8FA',
  flexDirection: 'column',
  padding: '16px',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '20px',
})

const NotFoundRoot = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100vw',
  justifyContent: 'flex-start',
  marginTop: '50px',
})

export const NotFound = () => {
  // Get functions from Redux.
  // If functions is empty, return <></> instead of NotFoundRoot.
  // Without this check, NotFound would render even if functions haven't finished loading yet.
  const { functions, projects, projectUuid } = useSelector(
    (state: AllState) => ({
      functions: state.appFunction.functions,
      projects: state.project.assigned,
      projectUuid: state.project.selected,
    })
  )
  // The logic below is just for temporary use.
  // This logic aims to login to project and avoid flickering when user access NotFound page
  const [initialized, setInitialized] = useState<boolean>(false)
  const [fetchProjectCalled, setFetchProjectCalled] = useState<boolean>(false)
  const [loggedInToProject, setLoggedInToProject] = useState<boolean>(false)
  const dispatch = useDispatch()
  useEffect(() => {
    const fetchProject = async () => {
      if (projects.length === 0) return
      const url = new URL(window.location.href)
      const pathArray = url.pathname.split('/')
      const lastPath = pathArray[pathArray.length - 1]
      const isAssignedProject = projects.some(
        project => project.code === lastPath
      )
      if (isAssignedProject) {
        dispatch(loginToProjectByCode(lastPath))
        setLoggedInToProject(true)
      }
      setFetchProjectCalled(true)
    }
    if (projectUuid) return
    fetchProject()
  }, [dispatch, projectUuid, projects])
  useEffect(() => {
    if (!fetchProjectCalled) return
    if (loggedInToProject && projectUuid) {
      setTimeout(() => setInitialized(true), 200)
      return
    }
    if (!loggedInToProject) {
      setInitialized(true)
      return
    }
  }, [fetchProjectCalled, loggedInToProject, projectUuid])
  if (functions.length === 0 || !initialized) return <></>
  return (
    <NotFoundRoot>
      <img
        src={people_at_the_table}
        width={300}
        height={233.82}
        style={{ margin: '20px' }}
      />
      <img
        src={flagxs_logo_tagline_monotone}
        width={220}
        height={61.45}
        style={{ margin: '20px' }}
      />
      <NotFoundContent>
        <NotFoundTitle>
          {intl.formatMessage({ id: 'global.warning.unauthorized.function' })}
        </NotFoundTitle>
      </NotFoundContent>
    </NotFoundRoot>
  )
}
